import type { LucideIcon } from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";

export interface InboxEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  compact?: boolean;
}

export const InboxEmptyState: React.FC<InboxEmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact = false,
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center text-center px-6",
      compact ? "py-8 gap-2" : "py-12 gap-3",
      className,
    )}
  >
    <div
      className={cn(
        "rounded-full flex items-center justify-center bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
        compact ? "h-12 w-12" : "h-16 w-16",
      )}
    >
      <Icon className={compact ? "h-6 w-6" : "h-8 w-8"} strokeWidth={1.5} />
    </div>
    <p className={cn("font-medium text-foreground", compact ? "text-sm" : "text-base")}>
      {title}
    </p>
    {description ? (
      <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
        {description}
      </p>
    ) : null}
    {action ? <div className="mt-2">{action}</div> : null}
  </div>
);
